import React from 'react';
import classnames from 'classnames';
import Spinner from "../Spinner";
import logo from '../../../assets/logo@3x.png';
import styles from './SplashScreen.module.scss';

export interface SplashScreenProps {
  size?: 'full'
}

function SplashScreen({size}: SplashScreenProps) {
  return (
    <div className={classnames(styles.splashScreenContainer, {[styles.fullSize]: size === 'full'})}>
      <img
        src={logo}
        className={styles.splashScreenLogo}
        alt='logo'
      />
      <Spinner/>
    </div>
  );
}

export default SplashScreen;
